/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Jewellery_TypeInputs */

const en_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const es_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const fr_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const ja_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジュエリーの種類`)
};

const zh_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const ar_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع`)
};

const id_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const it_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ru_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип изделия`)
};

const pt_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ko_field_jewellery_type = /** @type {(inputs: Field_Jewellery_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유형`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Field_Jewellery_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_jewellery_type = /** @type {((inputs?: Field_Jewellery_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Jewellery_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_jewellery_type(inputs)
	if (locale === "es") return es_field_jewellery_type(inputs)
	if (locale === "fr") return fr_field_jewellery_type(inputs)
	if (locale === "de") return de_field_jewellery_type(inputs)
	if (locale === "ja") return ja_field_jewellery_type(inputs)
	if (locale === "zh") return zh_field_jewellery_type(inputs)
	if (locale === "ar") return ar_field_jewellery_type(inputs)
	if (locale === "id") return id_field_jewellery_type(inputs)
	if (locale === "it") return it_field_jewellery_type(inputs)
	if (locale === "ru") return ru_field_jewellery_type(inputs)
	if (locale === "pt") return pt_field_jewellery_type(inputs)
	return ko_field_jewellery_type(inputs)
});